import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "show-configurations",
  class: "d-flex flex-fill list-page"
}
const _hoisted_2 = { class: "d-flex flex-row justify-content-between" }
const _hoisted_3 = { class: "col d-flex" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "btn-label" }
const _hoisted_6 = { class: "btn-text" }
const _hoisted_7 = { class: "col d-flex flex-row align-items-center justify-content-center" }
const _hoisted_8 = {
  id: "action-loading",
  class: "spinner-border spinner-border-sm"
}
const _hoisted_9 = { class: "pagination-wrapper mt-1" }

import {
  ElCard,
  ElTable,
  ElTableColumn,
  ElButton,
  ElInput,
  ElDropdown,
  ElDropdownMenu,
  ElDropdownItem,
  ElDivider,
} from "element-plus";
import { onMounted, ref, computed } from "vue";
import { getAllConfigurations } from "@/configuration/services/configuration.service";
import { router } from "@/core/router";
import { hasPermission } from "@/core/auth";
import i18n from "@/core/i18n/i18n";
import OneTegPagination from "@/common/components/OneTegPagination.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Configurations',
  setup(__props) {

const { t } = i18n.global;
const configurationList = ref([]);
const loadingConfigurations = ref(false);

const search = ref("");

const perPageConfigurations = ref(10);

const currentPageConfigurations = ref(1);

const numberOfConfigurations = computed(() =>
  configurationList.value ? configurationList.value.length : 0
);

const numberOfPagesConfigurations = computed(() => {
  if (numberOfConfigurations.value) {
    return Math.ceil(
      numberOfConfigurations.value / perPageConfigurations.value
    );
  }
  return 0;
});

const configurationsTableData = computed(() => {
  if (configurationList.value) {
    if (numberOfPagesConfigurations.value === 1) {
      return configurationList.value;
    }
    const start =
      (currentPageConfigurations.value - 1) * perPageConfigurations.value;
    const end = currentPageConfigurations.value * perPageConfigurations.value;
    return configurationList.value.slice(start, end);
  }
  return [];
});

function goToEditPage(row: any) {
  if (hasPermission("CONFIGURATIONS.LIST.EDIT")) {
    // Pass all required parameters for API calls
    router.push(`/configurations/edit/${row.key}/${row.level}/${row.ownerId}`);
  }
}

function sizeChanged(val) {
  perPageConfigurations.value = val;
}

async function getConfigurations() {
  loadingConfigurations.value = true;
  // Using getConfigurationSettings to match settings service pattern
  await getAllConfigurations() // Placeholder - would use actual tenant ID in real implementation
    .then((list) => {
      if (list) {
        configurationList.value = list;
      }
    })
    .catch((error) => {
      console.error("Error fetching configurations:", error);
    });
  loadingConfigurations.value = false;
}

onMounted(() => {
  getConfigurations();
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ElCard), { class: "card border-0 oneTeg-card oneTeg-card-body" }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElTable), {
          data: 
          search.value
            ? configurationList.value.filter(
                (data) =>
                  data.key?.toLowerCase().includes(search.value.toLowerCase()) ||
                  data.value?.toLowerCase().includes(search.value.toLowerCase()) ||
                  data.defaultValue
                    ?.toLowerCase()
                    .includes(search.value.toLowerCase()) ||
                  data.description?.toLowerCase().includes(search.value.toLowerCase())
              )
            : configurationsTableData.value
        ,
          "empty-text": loadingConfigurations.value ? ' ' : 'No Data',
          onRowClick: goToEditPage,
          "row-class-name": 
          _unref(hasPermission)('CONFIGURATIONS.LIST.EDIT')
            ? 'oneTeg-table-row-permission'
            : 'oneTeg-table-row-no-permission'
        ,
          height: "97%",
          class: "oneTeg-table"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElTableColumn), {
              label: _unref(t)('Common.Name'),
              prop: "name",
              sortable: "",
              width: "auto"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("strong", null, _toDisplayString(scope.row.key), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(ElTableColumn), {
              label: _unref(t)('Common.Value'),
              prop: "value",
              width: "auto"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.value), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(ElTableColumn), {
              label: _unref(t)('Common.DefaultValue'),
              prop: "defaultValue",
              width: "auto"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.defaultValue), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(ElTableColumn), {
              label: _unref(t)('Common.Description'),
              prop: "description",
              width: "auto"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.description), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(ElTableColumn), {
              prop: "actions",
              width: "300px"
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_unref(ElInput), {
                    modelValue: search.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
                    size: "mini",
                    class: "max-w-170",
                    placeholder: _unref(t)('Common.TypeToSearch')
                  }, null, 8, ["modelValue", "placeholder"]),
                  _createVNode(_unref(ElDivider), {
                    direction: "vertical",
                    class: "v-divider-stretch",
                    "aria-hidden": "true"
                  }),
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_unref(ElButton), {
                      loading: loadingConfigurations.value,
                      id: "refresh-button",
                      onClick: getConfigurations,
                      class: "no-border btn-oneTeg-table-create btn-labeled margin-left-3",
                      size: "mini",
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_4, [
                          _createElementVNode("span", _hoisted_5, [
                            _createVNode(_component_font_awesome_icon, { icon: "redo-alt" })
                          ]),
                          _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)("Common.Refresh")), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ])
                ])
              ]),
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_unref(ElDropdown), null, {
                    dropdown: _withCtx(() => [
                      _createVNode(_unref(ElDropdownMenu), null, {
                        default: _withCtx(() => [
                          (_unref(hasPermission)('CONFIGURATIONS.LIST.EDIT'))
                            ? (_openBlock(), _createBlock(_unref(ElDropdownItem), {
                                key: 0,
                                onClick: _withModifiers(($event: any) => (
                        _unref(router).push(
                          '/configurations/edit/' +
                            scope.row.key +
                            '/' +
                            scope.row.level +
                            '/' +
                            scope.row.ownerId
                        )
                      ), ["stop"])
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)("Common.Edit")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(ElButton), {
                        class: "no-border btn-oneTeg show-on-row-hover",
                        size: "mini",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "cog" })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _withDirectives(_createElementVNode("span", _hoisted_8, null, 512), [
                  [_vShow, scope.row.loading]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "empty-text", "row-class-name"]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(OneTegPagination, {
            style: {"width":"auto"},
            "page-sizes": [10, 25, 50, 100],
            "page-size": perPageConfigurations.value,
            total: numberOfConfigurations.value,
            "current-page": currentPageConfigurations.value,
            "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((currentPageConfigurations).value = $event)),
            onSizeChange: sizeChanged
          }, null, 8, ["page-size", "total", "current-page"])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})